import { useQuery } from "@tanstack/react-query";
import { IS_FULL_NECESSARY_DATA_OF_CLIENT } from "@/constants/Query";
import { apiRequest } from "@/utils/apiRequest";
import { IIsFullUserNecessaryInfo } from "@/types/apiResponse.types";

export const useGetIsFullNecessaryDataOfClientRequest = (
  disabled?: boolean,
) => {
  return useQuery<{
    data: {
      data: IIsFullUserNecessaryInfo;
    };
  }>({
    queryKey: [IS_FULL_NECESSARY_DATA_OF_CLIENT],
    queryFn: () => apiRequest(IS_FULL_NECESSARY_DATA_OF_CLIENT, "get"),
    enabled: !disabled,
  });
};
